import { useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { STATUS } from '../../../../constants/commonConstants';
import { getProductSchematics } from '../../../../store/schematics/actions';
import ProductSchematicsErrorFeedback from './ProductSchematicsErrorFeedback';
import { DIAGRAMS_ID } from '../constants';
import DiagramsPlaceholder from './DiagramsPlaceholder';
import ProductSchematics from './ProductSchematics';
import { isEmpty } from '@app/utils';
import useEquipmentDrawer from '@app/hooks/useEquipmentDrawer';

const ProductDiagrams = () => {
  const dispatch = useDispatch();
  const [t] = useTranslation();
  const {
    openAddDrawer,
    openEditDrawer,
    openSelectDrawer,
    getDrawerComponent
  } = useEquipmentDrawer();
  const uniqueId = useSelector(s => s.products?.current);
  const myEquipmentList = useSelector(
    s => s.myEquipment?.equipments?.myEquipmentList
  );
  const selectedEquipment = useSelector(
    s => s.myEquipment.equipments.selectedEquipment
  );
  const { serialNumber = null, model = null } = selectedEquipment ?? {};
  const schematics = useSelector(s => s.schematics?.[serialNumber]?.[uniqueId]);
  const getSchematicsStatus = useSelector(
    s => s.schematics?.getSchematicsStatus
  );
  const didSchematicsCallResolve = getSchematicsStatus === STATUS.RESOLVED;
  const didSchematicsCallFail = getSchematicsStatus === STATUS.REJECTED;
  const isSchematicsLoading = getSchematicsStatus === STATUS.PENDING;

  const showSchematics =
    !!schematics?.schematicTitle && !isEmpty(schematics?.parts);

  const placeholderProps = {
    hasEquipmentSaved:
      Array.isArray(myEquipmentList) && !!myEquipmentList.length,
    hasSerialNumber: !!serialNumber,
    hasSelectedEquipment: !!model,
    isSchematicsLoading,
    openAddDrawer,
    openEditDrawer,
    openSelectDrawer
  };

  const getSchematics = useCallback(() => {
    if (serialNumber && !schematics) {
      dispatch(getProductSchematics());
    }
  }, [dispatch, schematics, serialNumber]);

  useEffect(() => {
    //We don't want to call diagrams if we already have information for tha part-machine combination
    getSchematics();
  }, [getSchematics]);

  return (
    <>
      <section
        className="position-relative w-100 py-3 min-height-200px"
        id={DIAGRAMS_ID}
      >
        <>
          {showSchematics && didSchematicsCallResolve ? (
            <ProductSchematics getSchematics={getSchematics} />
          ) : (
            <>
              <h2 className="h3 display-3 mb-3">
                {t('PDP_SCHEMATIC_DIAGRAM')}
              </h2>
              <ProductSchematicsErrorFeedback
                onClick={getSchematics}
                preventScroll
                showTryAgainButton
              />
              {!didSchematicsCallFail && (
                <DiagramsPlaceholder {...placeholderProps} />
              )}
            </>
          )}
        </>
      </section>
      {getDrawerComponent({
        currentEquipment: selectedEquipment,
        myEquipmentList: myEquipmentList
      })}
    </>
  );
};

export default ProductDiagrams;
